import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "children"];
import React, { forwardRef } from 'react';
import { useFilterLayoutClassNames } from './hooks/useFilterLayoutClassNames';
import { useFilterLayout } from './hooks/useFilterLayout';
import { FilterLayoutRoot, FilterLayoutMain, FilterLayoutLeftBar, FilterLayoutLeftBarContainer } from './style';
import { FILTER_LAYOUT_CLASS_PREFIX } from './constants';
import { useComponentTheme } from '../../../utils/hooks';
export var FilterLayout = forwardRef(function FilterLayout(_ref, ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var theme = useComponentTheme(FILTER_LAYOUT_CLASS_PREFIX);
  var classNames = useFilterLayoutClassNames(FILTER_LAYOUT_CLASS_PREFIX, className);

  var _useFilterLayout = useFilterLayout(props, ref),
      rootProps = _useFilterLayout.rootProps,
      filterEditor = _useFilterLayout.filterEditor,
      leftBarProps = _useFilterLayout.leftBarProps,
      showLeftBar = _useFilterLayout.showLeftBar;

  return React.createElement(FilterLayoutRoot, Object.assign({}, rootProps, {
    theme: theme,
    className: classNames.Root
  }), showLeftBar && React.createElement(FilterLayoutLeftBar, Object.assign({}, leftBarProps, {
    theme: theme,
    className: classNames.LeftBar
  }), React.createElement(FilterLayoutLeftBarContainer, {
    theme: theme,
    className: classNames.LeftBarContainer
  }, filterEditor)), React.createElement(FilterLayoutMain, {
    theme: theme,
    className: classNames.Main
  }, children));
});
FilterLayout.defaultProps = {};